import type { RouteObject } from 'react-router-dom';
import CoursesPage from '@pages/CoursesPage/CoursesPage';
import CourseDetailsPage from '@pages/CoursesPage/CourseDetailsPage/CourseDetailsPage';
import MentorsPage from '@pages/MentorsPage/MentorsPage';
import ModuleTemplatesPage from '@pages/ModuleTemplatesPage/ModuleTemplatesPage';

const mastersRoutes: RouteObject[] = [
    { path: '/admin/courses', element: <CoursesPage /> },
    { path: '/admin/courses/:id', element: <CourseDetailsPage /> },
    { path: '/admin/mentors', element: <MentorsPage /> },
    { path: '/admin/module-templates', element: <ModuleTemplatesPage /> },
];

export default mastersRoutes;

